module.exports = __webpack_public_path__ + "img/img_level_19.28a330fd.png";